const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');

// @actions
const cardMobileRechargeActions = require('actions/cardMobileRecharge');

// @components
const { CardMobileRechargeStep1 } = require('components/cards/cardMobileRechargeSteps/cardMobileRechargeStep1/cardMobileRechargeStep1');
const CardMobileRechargeStep2 = require('components/cards/cardMobileRechargeSteps/cardMobileRechargeStep2/cardMobileRechargeStep2');
const CardMobileRechargeSuccessStep = require('components/cards/cardMobileRechargeSteps/cardMobileRechargeSuccessStep/cardMobileRechargeSuccessStep');
const CardMobileRechargeErrorStep = require('components/cards/cardMobileRechargeSteps/cardMobileRechargeErrorStep/cardMobileRechargeErrorStep');
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');

// @utilities
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');

// @constants
const { GRAPHIC_TUTOR_TYPE_4, FIRST_STEP } = require('constants/index');

class CardMobileRechargeView extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } }, setUpStep } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_MOBILE_RECHARGE, { immCard }, history);

        setUpStep(FIRST_STEP);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/recarga-movil', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        this.props.resetView();
    }

    onCancel() {
        const { history, match: { params: { cardId } } } = this.props;
        history.push(`/myprofile/cards/${cardId}/movements`);
    }

    onFinish() {
        const { match: { params: { cardId } }, mobileRecharge } = this.props;
        mobileRecharge(cardId);
    }

    buildWizard() {
        const { immCardMobileRecharge, match: { params: { cardId } }, immCards, setUpStep } = this.props;
        const immSteps = immCardMobileRecharge.get('steps');
        const visibleStep = immCardMobileRecharge.get('visibleStep');

        const actions = {
            validateStep: this.props.validateStep,
            setWillCancel: this.props.setWillCancel,
            setVisibleStep: this.props.setVisibleStep,
            finish: this.onFinish,
            cancel: this.onCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                isFetching={false}
                showPreLeaveModal={true}>
                <WizardStep position="first" cancelButton={true}>
                    <CardMobileRechargeStep1
                        immCardMobileRecharge={immCardMobileRecharge}
                        setUpStep={setUpStep}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    position="last"
                    immFinalButton="cardMobileRecharge-finalButtonLabel"
                    cancelButton={true}>
                    <CardMobileRechargeStep2
                        cardId={cardId}
                        immCards={immCards}
                        immCardMobileRecharge={immCardMobileRecharge}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    render() {
        const { match: { params: { cardId } }, immCards, immCardMobileRecharge } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        let block;

        if (immCard) {
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-cardsMobileRecharge')
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText('tutorials-cardsChargeTitle')}
                />
            );
            const hasError = !!immCardMobileRecharge.get('error');
            let bodyBlock;

            if (immCardMobileRecharge.get('submitSuccessful')) {
                bodyBlock = (
                    <CardMobileRechargeSuccessStep
                        immCard={immCard}
                        immCardMobileRecharge={this.props.immCardMobileRecharge}
                    />
                );
            } else if (hasError) {
                bodyBlock = (
                    <CardMobileRechargeErrorStep
                        immCard={immCard}
                    />
                );
            } else {
                const wizard = this.buildWizard(cardId);
                bodyBlock = (
                    <div>
                        {/* >> CONTENT DUPLICATED: REF-01 */}
                        <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                            <CardDetailsSideBar immCard={immCard} />
                        </div>
                        {/* CONTENT DUPLICATED: REF-01 << */}
                        <div className="col-md-12 col-lg-8">
                            {wizard}
                        </div>
                        {/* >> REF-01 */}
                        <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                            <CardDetailsSideBar immCard={immCard} />
                        </div>
                        {/* REF-01 << */}
                    </div>
                );
            }

            block = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle('cardMobileRecharge-headerTitle')}>
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {bodyBlock}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            block = <LoadingSection />;
        }

        return block;
    }
}

CardMobileRechargeView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardMobileRecharge: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    mobileRecharge: PropTypes.func.isRequired,
    resetView: PropTypes.func.isRequired,
    setUpStep: PropTypes.func.isRequired
};

module.exports.constructor = CardMobileRechargeView;
module.exports.CardMobileRechargeView = connect(
    state => ({
        immCards: state.cards,
        immCardMobileRecharge: state.cardMobileRecharge
    }), {
    validateStep: cardMobileRechargeActions.validateStep,
    setWillCancel: cardMobileRechargeActions.setWillCancel,
    setVisibleStep: cardMobileRechargeActions.setVisibleStep,
    mobileRecharge: cardMobileRechargeActions.mobileRecharge,
    resetView: cardMobileRechargeActions.resetView,
    setUpStep: cardMobileRechargeActions.setUpStep
})(withRouter(CardMobileRechargeView));
